import {initBotId} from 'botid/client/core';

import {BOT_PROTECTED_ROUTES} from '@/utils/botGuard/constants';

initBotId({protect: BOT_PROTECTED_ROUTES});
